export const TITLE = 'Answer Name';
export const PLACEHOLDER = 'Mitochondria';
